// src/pages/FaleConosco/Ouvidoria.tsx
import React, { useState } from 'react';
import { Box, Button, Container, TextField, Typography, Paper } from '@mui/material';

const Ouvidoria: React.FC = () => {
  const [nome, setNome] = useState('');
  const [email, setEmail] = useState('');
  const [mensagem, setMensagem] = useState('');
  const [errors, setErrors] = useState<{ nome?: string; email?: string; mensagem?: string }>({});

  // Regex simples para validar e-mail
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const validate = () => {
    const newErrors: typeof errors = {};
    if (!nome.trim()) newErrors.nome = 'Informe seu nome.';
    if (!email.trim()) newErrors.email = 'Informe seu e-mail.';
    else if (!emailRegex.test(email.trim())) newErrors.email = 'Formato de e-mail inválido.';
    if (!mensagem.trim()) newErrors.mensagem = 'Escreva sua mensagem.';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!validate()) return;

    const subject = encodeURIComponent(`Manifestação - Ouvidoria - ${nome}`);
    const body = encodeURIComponent(`Nome: ${nome}\nE-mail: ${email}\n\nMensagem:\n${mensagem}`);
    window.location.href = `mailto:cpa@am.senac.br?subject=${subject}&body=${body}`;

    setNome('');
    setEmail('');
    setMensagem('');
    setErrors({});
  };

  return (
    <Container maxWidth="md" sx={{ py: 6 }}>
      <Paper elevation={3} sx={{ p: 4, borderRadius: 3 }}>
        <Typography
          variant="h4"
          component="h1"
          gutterBottom
          sx={{
            fontFamily: 'Playfair Display, serif',
            fontWeight: 600,
            color: 'primary.main',
            textAlign: 'center',
            mb: 3,
          }}
        >
          Ouvidoria
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontSize: '1.1rem',
            textAlign: 'justify',
            fontFamily: 'Inter, sans-serif',
            color: 'text.primary',
          }}
        >
          Utilize este espaço para registrar sugestões, elogios ou reclamações referentes à instituição.
          Sua opinião é muito importante para aprimorarmos nossos serviços.
        </Typography>

        {/* Botão mailto logo abaixo do conteúdo da ouvidoria */}
        <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
          <Button
            variant="outlined"
            color="secondary"
            component="a"
            href="mailto:cpa@am.senac.br?subject=Manifestação%20-%20Ouvidoria"
          >
            Enviar e-mail para a Ouvidoria (cpa@am.senac.br)
          </Button>
        </Box>
      </Paper>

      <Paper elevation={3} sx={{ p: 4, borderRadius: 3, mt: 3 }}>
        <Box component="form" noValidate autoComplete="off" onSubmit={onSubmit}>
          <TextField
            label="Seu nome"
            fullWidth
            required
            variant="outlined"
            margin="normal"
            value={nome}
            onChange={(e) => setNome(e.target.value)}
            error={Boolean(errors.nome)}
            helperText={errors.nome || ' '}
          />
          <TextField
            label="Seu e-mail"
            fullWidth
            required
            type="email"
            variant="outlined"
            margin="normal"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            error={Boolean(errors.email)}
            helperText={errors.email || ' '}
          />
          <TextField
            label="Sua mensagem"
            fullWidth
            required
            multiline
            rows={5}
            variant="outlined"
            margin="normal"
            value={mensagem}
            onChange={(e) => setMensagem(e.target.value)}
            error={Boolean(errors.mensagem)}
            helperText={errors.mensagem || ' '}
          />

          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            sx={{
              mt: 3,
              fontWeight: 600,
              textTransform: 'none',
              borderRadius: 2,
            }}
          >
            Enviar
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default Ouvidoria;
